import { ColumnPreferencesServiceImplFactory } from "../../core/impl/columnPreferencesServiceImpl";

type IColumnPreferencesService = ReturnType<
  typeof ColumnPreferencesServiceImplFactory
>;

export type IColumnPreferencesController = ReturnType<
  typeof ColumnPreferencesControllerFactory
>;

export const ColumnPreferencesControllerFactory = ({
  columnPreferencesService,
}: {
  columnPreferencesService: IColumnPreferencesService;
}) => {
  const getColumnPreferences = async (viewKey: string) => {
    return await columnPreferencesService.getColumnPreferences(viewKey);
  };

  const saveColumnPreferences = async (
    viewKey: string,
    selectedColumns: string[]
  ) => {
    return await columnPreferencesService.saveColumnPreferences(
      viewKey,
      selectedColumns
    );
  };

  return {
    getColumnPreferences,
    saveColumnPreferences,
  };
};
